<template>
  <form @submit.prevent="submitForm()">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/student-credits`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Редактирование кредитов обучающегося</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3">
              ИИН
            </label>
            <div class="col-md-9">
              <input class="form-control" id="iin" type="text"
                     :disabled="true"
                     v-model="student.iin">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="lastname" class="form-label col-md-3">
              Фамилия
            </label>
            <div class="col-md-9">
              <input class="form-control" id="lastname" type="text"
                     :disabled="true"
                     v-model="student.lastname">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="firstname" class="form-label col-md-3">
              Имя
            </label>
            <div class="col-md-9">
              <input class="form-control" id="firstname" type="text"
                     :disabled="true"
                     v-model="student.firstname">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="patronymic" class="form-label col-md-3">
              Отчество
            </label>
            <div class="col-md-9">
              <input class="form-control" id="patronymic" type="text"
                     :disabled="true"
                     v-model="student.patronymic">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="credits" class="form-label col-md-3">
              Кредиты
            </label>
            <div class="col-md-9">
              <input class="form-control" id="credits" type="number" :min="0" :step="1"
                     v-model="student.credits.credits"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="totalCreditsGranted" class="form-label col-md-3">
              Предоставленно кредитов
            </label>
            <div class="col-md-9">
              <input class="form-control" id="totalCreditsGranted" type="number" :min="0" :step="1"
                     v-model="student.credits.totalCreditsGranted"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month1" class="form-label col-md-3">
              Январь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month1" type="number" :min="0" :step="1"
                     v-model="student.credits.month1"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month2" class="form-label col-md-3">
              Февраль
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month2" type="number" :min="0" :step="1"
                     v-model="student.credits.month2"
                     required>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month3" class="form-label col-md-3">
              Март
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month3" type="number" :min="0" :step="1"
                     v-model="student.credits.month3"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month4" class="form-label col-md-3">
              Апрель
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month4" type="number" :min="0" :step="1"
                     v-model="student.credits.month4"
                     required>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month5" class="form-label col-md-3">
              Май
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month5" type="number" :min="0" :step="1"
                     v-model="student.credits.month5"
                     required>
            </div>
          </div>
        </div>
      </div>



      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month6" class="form-label col-md-3">
              Июнь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month6" type="number" :min="0" :step="1"
                     v-model="student.credits.month6"
                     required>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month7" class="form-label col-md-3">
              Июль
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month7" type="number" :min="0" :step="1"
                     v-model="student.credits.month7"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month8" class="form-label col-md-3">
              Август
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month8" type="number" :min="0" :step="1"
                     v-model="student.credits.month8"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month9" class="form-label col-md-3">
              Сентябрь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month9" type="number" :min="0" :step="1"
                     v-model="student.credits.month9"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month10" class="form-label col-md-3">
              Октябрь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month10" type="number" :min="0" :step="1"
                     v-model="student.credits.month10"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month11" class="form-label col-md-3">
              Ноябрь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month11" type="number" :min="0" :step="1"
                     v-model="student.credits.month11"
                     required>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="month12" class="form-label col-md-3">
              Декабрь
            </label>
            <div class="col-md-9">
              <input class="form-control" id="month12" type="number" :min="0" :step="1"
                     v-model="student.credits.month12"
                     required>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="page-footer justify-content-end">
      <b-button variant="success" type="submit" v-if="hasEditPermission()">
        Сохранить
      </b-button>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentCreditsService from "@/services/studentCreditsService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";

export default {
  components: {
    VueLoading
  },
  computed: {
    studentId() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      student: {
        uuid: null,
        trancheYear: null,
        trancheNumber: null,
        credits: {
          uuid: null,
          credits: null,
          totalCreditsGranted: null,
          month1: null,
          month2: null,
          month3: null,
          month4: null,
          month5: null,
          month6: null,
          month7: null,
          month8: null,
          month9: null,
          month10: null,
          month11: null,
          month12: null,
        },
        universityId: null,
        environmentalFactor: null,
        hasBranchEf: null,
        studentId: null,
        citizenshipId: null,
        iin: null,
        lastname: null,
        firstname: null,
        patronymic: null,
        degreeId: null,
        course: null,
        graduationCourse: null,
        deducted: null,
        admissionYear: null,
        gop: null,
        paymentFormId: null,
        quotaId: null,
        addStatusId: null,
        commentOvpo: null,
        environmentalFactorId: null,
        sightInvalid: null,
        sightInvalidBegin: null,
        sightInvalidEnd: null,
        hearingInvalid: null,
        hearingInvalidBegin: null,
        hearingInvalidEnd: null,
        orphan: null,
        stateProvisionOrphan: null,
        commentFc: null,
        enrollOrderDate: null,
        enrollOrderNumber: null,
        enrollOrderMoveDate: null,
        deductOrderDate: null,
        deductOrderNumber: null,
        deductOrderMoveDate: null,
        deductOrderTransferDate: null,
        deductOrderTransferNumber: null,
        deductOrderTransferMoveDate: null,
        deductOrderTransferUniversityDomestic: null,
        deductOrderTransferUniversityForeign: null,
        academicLeaveOrderDate: null,
        academicLeaveOrderNumber: null,
        academicLeaveOrderMoveDate: null,
        academicLeaveOrderStartDate: null,
        academicLeaveOrderFinishDate: null,
        academicLeaveOrderReason: null,
        academicLeaveOrderSickLeaveStartDate: null,
        academicLeaveOrderSickLeaveFinishDate: null,
        orderChangeGopDate: null,
        orderChangeGopNumber: null,
        orderChangeGopMoveDate: null,
        orderChangeGopOldGop: null,
        orderChangePaymentFormGrantDate: null,
        orderChangePaymentFormGrantNumber: null,
        orderChangePaymentFormGrantMoveDate: null,
        orderAcademicMobilityDate: null,
        orderAcademicMobilityNumber: null,
        orderAcademicMobilityMoveDate: null,
        orderAcademicMobilityUniversityDomestic: null,
        orderAcademicMobilityUniversityForeign: null,
        orderAcademicMobilityStartDate: null,
        orderAcademicMobilityFinishDate: null,
        orderDoubleEducationDate: null,
        orderDoubleEducationNumber: null,
        orderDoubleEducationMoveDate: null,
        orderDoubleEducationUniversityDomestic: null,
        orderDoubleEducationUniversityForeign: null,
        orderDoubleEducationStartDate: null,
        orderDoubleEducationFinishDate: null,
        enrollOrderFoundDate: null,
        enrollOrderFoundNumber: null,
        enrollOrderFoundMoveDate: null,
        deductOrderFoundDate: null,
        deductOrderFoundNumber: null,
        deductOrderFoundMoveDate: null,
        orderScholarshipDate: null,
        orderScholarshipNumber: null,
        orderScholarshipFoundDate: null,
        orderScholarshipFoundNumber: null,
        scholarshipPeriodStart: null,
        scholarshipPeriodEnd: null,
        scholarshipType: null
      }
    };
  },
  methods: {
    init() {
      this.findById(this.studentId);
    },
    async findById(studentId) {
      this.isLoading = true;
      this.student = await studentCreditsService.findById(studentId);
      if (this.student.credits == null) {
        this.student.credits = {};
      }
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;

        this.student = await studentCreditsService.save(this.student);

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    hasEditPermission() {
      return this.isUniversityManager();
    },
    isAdmin() {
      return delegationService.isAdmin();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}
</style>
